import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Auth, SearchCache } from 'src/common';
import { TranslationManager } from 'src/common/translation';

@Component({
    selector: 'home-page',
    templateUrl: './home-page.component.html'
})
export class HomePageComponent implements OnInit {

    translationManager = TranslationManager;
    auth = Auth;
    isAuthenticated: boolean = this.auth.isAuthenticated;

    constructor(private router: Router) {}

    ngOnInit(): void {
      if(!this.isAuthenticated){
        this.router.navigate(['/unauthorized']);
      }
    }
}
